import axios from "axios";

import config from "../frontend.config.json";

const BACKEND_ORIGIN = config.BACKEND_ORIGIN;

const DashboardAPI = {
  getDayVisitsCount: async (token) => {
    return await axios({
      method: "GET",
      url: `${BACKEND_ORIGIN}/api/dashboard/day-visits`,
      headers: { Authorization: token },
    });
  },
  getMonthVisitsCount: async (token) => {
    return await axios({
      method: "GET",
      url: `${BACKEND_ORIGIN}/api/dashboard/month-visits`,
      headers: { Authorization: token },
    });
  },
  getEntriesFlow: async (token) => {
    return await axios({
      method: "GET",
      url: `${BACKEND_ORIGIN}/api/dashboard/entries-flow`,
      headers: { Authorization: token },
    });
  },
};

export default DashboardAPI;
